import { Typography } from "@mui/material";

const CreateZonePageHeader = (): JSX.Element => {
  return <Typography variant="h3">Create Zone</Typography>;
};

export default CreateZonePageHeader;
